import request from '@/api-v2/request';
import type { AttributeBLMParameter } from './types/AttributeBLMParameter';
import type { BLMView } from './types/BLMView';
import type { AxiosResponse } from 'axios';

export const getBlmViews = (signal: AbortSignal): Promise<BLMView[]> =>
  request({
    url: `/blm/options`,
    method: 'get',
    signal,
  }).then(
    (o): BLMView[] => o.data,
    (err) => {
      console.error(err);
      throw err;
    },
  );

export const createBlmView = ({
  name,
  parameter,
}: {
  name: string;
  parameter: AttributeBLMParameter[];
}): Promise<BLMView> =>
  request({
    url: `/blm/options`,
    method: 'post',
    data: { name, parameter },
  }).then(
    (o): BLMView => o.data,
    (err) => {
      console.error(err);
      throw err;
    },
  );

export const updateBlmView = ({ attributeId, view }: { attributeId: string; view: BLMView }): Promise<BLMView> =>
  request({
    url: `/blm/options/${attributeId}`,
    method: 'PUT',
    data: { name: view.name, parameter: view.parameter },
  }).then(
    (o): BLMView => o.data,
    (err) => {
      console.error(err);
      throw err;
    },
  );

export const deleteBlmView = ({ attributeId }: { attributeId: string }): Promise<AxiosResponse> =>
  request({
    url: `/blm/options/${attributeId}`,
    method: 'DELETE',
  }).then(
    (o): AxiosResponse => o,
    (err) => {
      console.error(err);
      throw err;
    },
  );
